import { useRef } from 'react'
import { useIsOverflowing } from '../../utils/hooks/use-is-overflowing'
import { TooltipWithHover } from '../tooltip'
import * as styles from './branch-tag.css'

type BranchTagProps = {
  branch?: string | null
}

export const BranchTag: React.FC<BranchTagProps> = ({ branch }) => {
  const textRef = useRef<HTMLSpanElement>(null)
  const isOverflowing = useIsOverflowing(textRef, [branch])

  if (!branch) {
    return null
  }

  const branchElement = (
    <span ref={textRef} className={styles.branchText}>
      {branch}
    </span>
  )

  return (
    <div className={styles.branchContainer}>
      {isOverflowing ? (
        <TooltipWithHover trigger={branchElement}>
          <span>{branch}</span>
        </TooltipWithHover>
      ) : (
        branchElement
      )}
    </div>
  )
}
